
import "../styles/blogPost.css";
import Footer from "../../../../../components/Footer/Footer";
import useBlogList from "../hooks/useBlogPost";
import Breadcrumbs from "../../../../../components/Breadcrumbs/Breadcrumbs";
import { Link, useParams } from "react-router-dom";
import insta from '../../../../../assets/icons/Insta.png';
import facebookimg from "../../../../../assets/icons/facebook.png";
import BlogBanner from "../components/BlogBanner";
import LeftBlogContent from "../components/LeftBlogContent";
import RightBlogContent from "../components/RightBlogContent";
import ConnectWithus from "../components/ConnectWithus";
import RecommendedPosts from "../components/RecommendedPosts";
import RecommendedPostWeb from "../components/RecommendedPostWeb";
import RelatedPost from "../components/RelatedPost";

const BlogPostPage = () => {
  const { slug } = useParams();
  const { data, status, error, breadcrumbPaths, instagramShareUrl, facebookShareUrl } = useBlogList(slug);
  if (status === "loading") return <div className="blog-loading">Loading blogs...</div>;
  if (status === "failed") return <div className="blog-error">Error: {error}</div>;
  if (!data) return null;

  return (
    <>
      <Breadcrumbs paths={breadcrumbPaths} />
      <div className="blog-post">
        <BlogBanner data={data} />
        {/* Main Section */}
        <section className="post-wrapper">
          <LeftBlogContent data={data} />
          <RightBlogContent data={data} Link={Link} />
        </section>
        <ConnectWithus data={data} instagramShareUrl={instagramShareUrl} facebookShareUrl={facebookShareUrl} insta={insta} facebookimg={facebookimg} />
        {/* Recommended Posts Mobile */}
        <RecommendedPosts data={data} Link={Link} />
        {/* Recommended Posts */}
        <RecommendedPostWeb data={data} Link={Link} />
        {/* Releted Posts Mobile*/}
        <RelatedPost Data={data} Link={Link} />
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default BlogPostPage;